// AUTO-GENERATED: DO NOT EDIT
export const envExports = {
requestURL: "https://website-pub.polycaik.com/dom/polycaik-request",
requestPUT: (d) => ({
headers: {'Content-Type': 'application/json'},
method: "PUT",
body: JSON.stringify(d)})};
